module.exports = __webpack_public_path__ + "static/img/tubka_y.9731fec7.png";